import { useEffect, useState } from 'react';
import axios from 'axios';
import endpoints from '../define/endpoints';
import { camelizeKeys } from 'humps';

export function useProduct(productId) {
  const [product, setProduct] = useState(null);
  useEffect(() => {
    (async function () {
      if (productId) {
        const { data } = await axios.get(
          `${endpoints.core}/products/${productId}`, {
          params: { locale: window.freedomeConfig.locale }
        }
        );
        setProduct(camelizeKeys(data));
      }
    })();
  }, [productId]);
  return product;
}
